import { Link, LinkProps } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router";

interface LinkifyProps extends LinkProps {
  linkTo?: string;
}

export default function Linkify({ children, linkTo = undefined, ...rest }: LinkifyProps) {
  return linkTo ? (
    <Link as={RouterLink} to={linkTo} {...rest}>
      {children}
    </Link>
  ) : (
    children
  );
}
